import { GET_FEE_SUMMARIES_REQUEST, GET_FEE_SUMMARIES_SUCCESS, UPDATE_FEE_STATUSES_SUCCESS, GET_FEE_BY_ID_REQUEST, SET_FEE_ID, POST_FEE_SUCCESS, GET_FEE_BY_ID_SUCCESS, UPDATE_FEE_SUCCESS, INSERT_FEE_COMMENT_SUCCESS } from './fees.types';

import produce from 'immer';

const initialState = {
  currentFeeId: null,
  fees: null,
  feeDetails: null,
  isLoadingFees: null,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_FEE_SUMMARIES_REQUEST:
    case GET_FEE_BY_ID_REQUEST:
      draft.isLoadingFees = true;
      break;

    case GET_FEE_SUMMARIES_SUCCESS:
    case UPDATE_FEE_STATUSES_SUCCESS:
      draft.fees = action.response;
      draft.isLoadingFees = false;
      break;

    case GET_FEE_BY_ID_SUCCESS:
    case POST_FEE_SUCCESS:
    case UPDATE_FEE_SUCCESS:
    case INSERT_FEE_COMMENT_SUCCESS:
        draft.feeDetails = action.response;
        draft.isLoadingFees = false;
        break;
    

    case SET_FEE_ID:
      draft.currentFeeId = action.response;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
